import { render, staticRenderFns } from "./dialog-contact-form-wrapper.vue?vue&type=template&id=91f25b0c"
import script from "./dialog-contact-form-wrapper.vue?vue&type=script&lang=js"
export * from "./dialog-contact-form-wrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('91f25b0c')) {
      api.createRecord('91f25b0c', component.options)
    } else {
      api.reload('91f25b0c', component.options)
    }
    module.hot.accept("./dialog-contact-form-wrapper.vue?vue&type=template&id=91f25b0c", function () {
      api.rerender('91f25b0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/pages/contact-list-index/dialog-contact-form-wrapper.vue"
export default component.exports